import React from 'react';
import './MainRules.scss';

const MainRules = () => {
    return (
        <div className='mainRules'>
            <h2 className='textTitle text-uppercase fw-medium'>Main Rules</h2>
            <p>Most of us wonder if there is a God and if He really is the God of the Bible. In the Bible
                God says ‘I will make your name great’ and today the name of Abraham/Abram is known
                worldwide. This promise has come true. The earliest copy of Genesis found in the Dead Sea
                Scrolls is dated 200-100 B.C. which means the promise has been in writing since at least
                that time. At that time the name of Abraham was not well-known so the promise came true only
                after it was written down, not before.
                <br/>
                <br/>
                The Jews who descended from Abraham were never really the nation we associate with
                greatness. They did not conquer and build a great empire like the Romans did or build large
                monuments like the Egyptians did with the pyramids. Their fame comes from the Law and Book
                which they wrote; from some remarkable individuals that were Jewish; and that they have
                survived as a somewhat different people group for thousands of years. Their greatness is not
                because of anything they did, but rather what was done to and through them. The promise says
                repeatedly “I will …” – that would be the power behind the promise. Their unique greatness
                happened because God made it happen rather than some ability, conquest or power of their
                own.</p>
        </div>
    );
};

export default MainRules;
